module.exports = __webpack_public_path__ + "static/img/Opening-Ceremony-Visual.e80654e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Opening-Ceremony-Visual.jpg
// module id = rs1H
// module chunks = 0